<template>
  <!--  批量修改标签操作-->
  <el-dialog
    :visible.sync="modal.inventoryVisible"
    width="500px"
    custom-class="dialog-center"
  >
    <el-form :model="data">
      <el-form-item label="请输入库存数量：" :label-width="formLabelWidth">
        <el-input v-model="data.num" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="modal.inventoryVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "UpdateInventory",
    props: {
      modal: Object
    },
    data() {
      return {
        formLabelWidth: '130px',
        data: {
          num: null,
        }
      }
    },
    methods: {
      handleConfirm() {
        console.log('data', this.data)
        this.$emit('handleInventory', this.data)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/pms/components/UpdateInventory.vue